import { render, staticRenderFns } from "./InvitationCreateAccount.vue?vue&type=template&id=30dced1a&scoped=true&"
import script from "./InvitationCreateAccount.vue?vue&type=script&lang=ts&"
export * from "./InvitationCreateAccount.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationCreateAccount.vue?vue&type=style&index=0&id=30dced1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dced1a",
  null
  
)

export default component.exports